import {
  MP_CHANGE_CURRENT_PROJECT_PAGE,
  MP_PROJECT_LAUNCH_LIST,
  MP_SEARCH_JOBS,
  MP_SET_PROJECT_ITEMS_PER_PAGE,
  MP_PROJECT_STATUS_FILTER,
  MP_LAUNCH_NOTES_LOADER,
  MP_LAUNCH_NOTES_LIST_SUCCESS,
  MP_LAUNCH_NOTES_LIST_FAIL,
  MP_LAUNCH_NOTE_ADD_SUCCESS,
  MP_LAUNCH_OFFER_LIST_FAIL,
  MP_LAUNCH_OFFER_LIST_SUCCESS,
  MP_LAUNCH_OFFER_ADD_SUCCESS,
  MP_LAUNCH_OFFER_LOADER,
  MP_RENEWAL_LOADER,
  MP_RENEWAL_LIST_SUCCESS,
  MP_RENEWAL_LIST_FAIL,
  MP_RENEWAL_ADD_SUCCESS,
  MP_RENEWAL_UPDATE_SUCCESS,
  MP_LAUNCH_DETAILS,
  CHANGE_VIEW_MP_LAUNCH_TAB
} from "../actions/mpLaunchesAction";

const initialState = {
  mpLaunchListing: [],
  mpLaunchTotalResults: null,
  mpLaunchTotalPages: null,
  mpLaunchPageIds: [],
  fetchingData: true,
  mpLaunchSearchText: "",
  mpLaunchCurrentPage: 1,
  mpLaunchListResultPerPage: 10,
  mpLaunchStatusFliter: [],
  notesList: [],
  notesLoading: false,
  offerList: [],
  offersLoading: false,
  renewalsList:[],
  renewalsLoading: false,
   initialTab: 0,
  tabValues: {},
};

const mpLaunchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MP_PROJECT_LAUNCH_LIST: {
      return {
        ...state,
        mpLaunchListing: action.payload.results,
        mpLaunchTotalResults: action.payload.total_results,
        mpLaunchTotalPages: action.payload.total_pages,
        mpLaunchPageIds: action.payload.page_ids,
        fetchingData: false,
      };
    }

    case MP_CHANGE_CURRENT_PROJECT_PAGE: {
      return {
        ...state,
        mpLaunchCurrentPage: action.payload,
      };
    }

    case MP_SET_PROJECT_ITEMS_PER_PAGE: {
      return {
        ...state,
        mpLaunchListResultPerPage: action.payload,
      };
    }
    case MP_SEARCH_JOBS: {
      return {
        ...state,
        mpLaunchSearchText: action.payload,
      };
    }

    case MP_PROJECT_STATUS_FILTER: {
      return {
        ...state,
        mpLaunchStatusFliter: action?.payload || [],
      };
    }
    case MP_LAUNCH_NOTES_LOADER:
      return { ...state, notesLoading: true };
    case MP_LAUNCH_NOTES_LIST_SUCCESS:
      return { ...state, notesList: action.payload, notesLoading: false };
    case MP_LAUNCH_NOTES_LIST_FAIL:
      return { ...state, notesList: [], notesLoading: false };
    case MP_LAUNCH_NOTE_ADD_SUCCESS:
      return { ...state };
    case MP_LAUNCH_OFFER_LIST_SUCCESS:
      return { ...state, offerList: action.payload, offersLoading: false };
    case MP_LAUNCH_OFFER_LIST_FAIL:
      return { ...state, offerList: [], offersLoading: false };
    case MP_LAUNCH_OFFER_ADD_SUCCESS:
      return { ...state };
    case MP_LAUNCH_OFFER_LOADER:
      return { ...state, offersLoading: true };
       case MP_RENEWAL_LIST_SUCCESS:
      return { ...state, renewalsList: action.payload, renewalsLoading: false };
    case MP_RENEWAL_LIST_FAIL:
      return { ...state, renewalsList: [], renewalsLoading: false };
    case MP_RENEWAL_ADD_SUCCESS:
      return { ...state };
    case MP_RENEWAL_UPDATE_SUCCESS:
      return { ...state }; 
    case MP_RENEWAL_LOADER:
      return { ...state, renewalsLoading: true };
       case MP_LAUNCH_DETAILS:{
      return{
        ...state,
        mpLaunchDetails:action.payload || []
      }
    }

      case CHANGE_VIEW_MP_LAUNCH_TAB: {
      return {
        ...state,
        initialTab: action.payload,
      };
    }
    default:
      return state;
  }
  
};

export default mpLaunchesReducer;
